/**
 * 性別類型列舉
 */
export enum VoiceGenderTypeEnum {
	/**
	 * 男性
	 */
	Male = 'male',
	/**
	 * 女性
	 */
	Female = 'female',
}
